import * as efficiencyAction from './efficiency-resource-action'

export {
  efficiencyAction,
}



// WEBPACK FOOTER //
// ./src/actions/efficiency-resource/index.js